import React from 'react';
import { DateInputField } from './InputField';
import CustomSelect from './CustomSelect.tsx';
import { Clock } from 'lucide-react';
import TimeSelect from './TimeSelect'; // Importamos el nuevo componente

interface FormData {
    startDate: string;
    endDate: string;
    activeHours: string[]; // Array de horas seleccionadas
    userSegment: string;
    allowedCountries: string[];
}

interface ScheduleAndTargetingProps {
    formData: FormData;
    setFormData: React.Dispatch<React.SetStateAction<FormData>>;
    userSegments: string[];
    countries: string[];
}

const ScheduleAndTargeting: React.FC<ScheduleAndTargetingProps> = ({ formData, setFormData, userSegments, countries }) => {
    return (
        <section className="space-y-6">
            <div className="pb-4 border-b border-gray-200">
                <h2 className="text-xl font-semibold text-gray-900 flex items-center">
                    <span className="bg-indigo-100 w-8 h-8 rounded-lg flex items-center justify-center mr-3">
                        <Clock size={18} className="text-indigo-600" />
                    </span>
                    Schedule & Targeting
                </h2>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
                <DateInputField
                    label="Start Date"
                    value={formData.startDate}
                    onChange={(e) => setFormData(prev => ({ ...prev, startDate: e.target.value }))}
                />
                <DateInputField
                    label="End Date"
                    value={formData.endDate}
                    onChange={(e) => setFormData(prev => ({ ...prev, endDate: e.target.value }))}
                />

                {/* Usamos el nuevo componente para seleccionar múltiples horas */}
                <TimeSelect
                    value={formData.activeHours || []}  // Aseguramos que activeHours siempre sea un array
                    onChange={(hours) => setFormData(prev => ({ ...prev, activeHours: hours }))} // Actualizamos el estado con las horas seleccionadas
                    format="24h" // Puede ser '12h' o '24h'
                />

                <CustomSelect
                    options={userSegments}
                    selected={formData.userSegment}
                    onChange={(segment) => setFormData(prev => ({ ...prev, userSegment: segment }))}
                    placeholder="Select user segment"
                />
                <CustomSelect
                    options={countries}
                    selected={formData.allowedCountries}
                    onChange={(selectedCountries) => setFormData(prev => ({ ...prev, allowedCountries: selectedCountries }))}
                    multiple
                    placeholder="Select countries"
                />
            </div>
        </section>
    );
};

export default ScheduleAndTargeting;
